import { render, staticRenderFns } from "./setpaypwd.vue?vue&type=template&id=296dedb4&scoped=true"
import script from "./setpaypwd.vue?vue&type=script&lang=js"
export * from "./setpaypwd.vue?vue&type=script&lang=js"
import style0 from "./setpaypwd.vue?vue&type=style&index=0&id=296dedb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296dedb4",
  null
  
)

export default component.exports